import { AnimaliaListItem } from '../../domain/entities/AnimaliaListItem';
import {
  AnimaliaListingCardDTO,
  AnimaliaListingMapper,
} from './AnimaliaListingMapper';

export interface AnimaliaSearchPageDTO {
  query: string;
  items: ReadonlyArray<AnimaliaListingCardDTO>;
  hasMore: false;
  resultCount: number;
}

export class AnimaliaSearchMapper {
  static toPageDTO(
    query: string,
    entities: ReadonlyArray<AnimaliaListItem>,
    detailReturnTo: string | null = null,
  ): AnimaliaSearchPageDTO {
    return {
      query,
      items: AnimaliaListingMapper.toCardCollectionDTO(entities, detailReturnTo),
      hasMore: false,
      resultCount: entities.length,
    };
  }
}
